import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./ColdWorkPermitForm.css";
import "./ColdWorkPermitInspectionView.css";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import API_URL from "../../src/Config";
import "react-datepicker/dist/react-datepicker.css";
import Tooltip from "@mui/material/Tooltip";
import { IoMdArrowBack } from "react-icons/io";
import ColdWorkPermitTemplate from "./ColdWorkPermitTemplate";
import ConfinedSpaceTemplate from "../ConfiedSpaceWorkPermit/ConfinedSpaceTemplate";
import RoadClosureTemplate from "../RoadClosureWorkPermit/RoadClosuereTemplate";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import HotWorkPermitTemplate from "../HotWorkPermit/HotWorkPermitTemplate";
import IsolationPermitTemplate from "../IsolationWorkPermit/IsolationPermitTemplate";
import { fetchIsolationPermit } from "../ElectricalIsolation/isolationPermitApi";

// const PDF_PAGE_WIDTH = 210;
// const PDF_PAGE_HEIGHT = 297;
// const PDF_MARGIN = 5;
// const ISOLATION_CAPTURE_WIDTH = 820;
// const ISOLATION_PRINT_WIDTH = PDF_PAGE_WIDTH - PDF_MARGIN * 2;
// const ISOLATION_PRINT_HEIGHT = PDF_PAGE_HEIGHT - PDF_MARGIN * 2;

function PermitPdfFormate({ isSidebarExpanded }) {
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const { permit_id, work_permit_name, wp_status } = useParams();
  const [severity, setSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [workDetails, setWorkDetails] = useState([]);
  const [clearanceRenewal, setClearanceRenewal] = useState([]);
  const [permitDetails, setPermitDetails] = useState(null);
  const [checklist, setChecklist] = useState([]);
  const [precautions, setPrecautions] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true); // For better UX
  const [reason, setReason] = useState(""); // Track reason input
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  // Add new state for PDF generation
  const [isPdfGenerating, setIsPdfGenerating] = useState(false);
  const pdfRef = useRef(null);
  const [isApprovePopupOpen, setIsApprovePopupOpen] = useState(false);
  const [showRejectPopup, setShowRejectPopup] = useState(false);
  const [excavationRemark, setExcavationRemark] = useState("");
  const [excavationFile, setExcavationFile] = useState(null);
  const [departmentApprovals, setDepartmentApprovals] = useState([]);

  const decodedWorkPermitName = decodeURIComponent(work_permit_name);
  const isIsolationPermit =
    decodedWorkPermitName === "Electrical Isolation/Energisation";
  const isExcavationPermit =
    decodedWorkPermitName === "Excavation Clearance/Road Closure";

  console.log("twinkle work_permit_name", work_permit_name);
  console.log("twinkle decodedWorkPermitName", decodedWorkPermitName);

  const handleApproveConfirm = () => {
    setIsApprovePopupOpen(true);
  };

  const handleRejectConfirm = () => {
    handleRejectClick(); // Call the original reject function
    setShowRejectPopup(false); // Close popup after rejection
  };

  const closeApprovePopup = () => {
    setIsApprovePopupOpen(false);
  };

  const confirmApprove = () => {
    handleSaveClick(); // Call the actual approve function
    setIsApprovePopupOpen(false); // Close popup after confirming
  };

  const handleReasonChange = (e) => {
    setReason(e.target.value);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const generatePDF = async () => {
    if (!pdfRef.current) return;

    try {
      setIsPdfGenerating(true);

      const pdf = new jsPDF("p", "mm", "a4");

      const tempDiv = document.createElement("div");
      tempDiv.style.position = "fixed";
      tempDiv.style.left = "-10000px";
      tempDiv.style.top = "0";
      tempDiv.style.width =
        isIsolationPermit
          ? "794px"
          : isExcavationPermit
          ? "1500px"
          : decodedWorkPermitName === "Hot Work"
          ? "1350px"
          : "794px";
      tempDiv.style.padding = "10px"; // 🔹 Removed extra padding
      tempDiv.style.margin = "0px"; // 🔹 Ensure no margin
      tempDiv.style.background = "white";
      tempDiv.style.padding = isIsolationPermit || isExcavationPermit ? "0" : "10px";
      tempDiv.style.margin = "0";
      tempDiv.style.boxSizing = "border-box";
      tempDiv.appendChild(pdfRef.current.cloneNode(true));

      document.body.appendChild(tempDiv);

      if (isExcavationPermit) {
        await document.fonts.ready;
        await Promise.all(
          Array.from(tempDiv.querySelectorAll("img")).map((image) =>
            image.decode ? image.decode().catch(() => {}) : Promise.resolve()
          )
        );
      }

      const section1 = tempDiv.querySelector("#section1");
      const section2 = tempDiv.querySelector("#section2");

      const canvasOptions = {
        scale: isIsolationPermit ? 2 : 1.6,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
        logging: false,
        imageTimeout: 15000,
        removeContainer: true,
        windowWidth: isIsolationPermit ? 794 : isExcavationPermit ? 1550 : undefined,
      };

      if (section1) {
        const canvas1 = await html2canvas(section1, canvasOptions);
        const imgData1 = canvas1.toDataURL("image/jpeg", 0.9);

        // if (isIsolationPermit) {
        //   pdf.addImage(
        //     imgData1,
        //     "JPEG",
        //     PDF_MARGIN,
        //     PDF_MARGIN,
        //     ISOLATION_PRINT_WIDTH,
        //     ISOLATION_PRINT_HEIGHT,
        //   );
        // } else {
        //   // 🔹 Reduced left/right/top margins from 10mm → 5mm for tighter fit
          pdf.addImage(imgData1, "JPEG", 5, 5, 200, 287);
        // }
      }

      if (section2) {
        pdf.addPage();
        const canvas2 = await html2canvas(section2, canvasOptions);
        const imgData2 = canvas2.toDataURL("image/jpeg", 0.9);
        pdf.addImage(imgData2, "JPEG", 5, 5, 200, 287);
      }

      document.body.removeChild(tempDiv);

      const pdfBlob = pdf.output("blob");
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setPdfUrl(pdfUrl);
      console.log("pdfUrl", pdfUrl);
    } catch (error) {
      console.error("Error generating PDF:", error);
      setError("Failed to generate PDF");
    } finally {
      setIsPdfGenerating(false);
    }
  };

  useEffect(() => {
    if (!permitDetails) return;
    generatePDF();
  }, [permitDetails]);

  useEffect(() => {
    const fetchPermitDetails = async () => {
      try {
        setLoading(true); // Make sure loading is true when starting
        if (isIsolationPermit) {
          const response = await fetchIsolationPermit(permit_id);
          if (response) {
            setPermitDetails(response);
            setChecklist([]);
            setWorkDetails(response?.permit || {});
            setClearanceRenewal([]);
            setPrecautions([{}]);
            setDepartmentApprovals([]);
          } else {
            console.warn("No isolation permit details found.");
            setError("No isolation permit details found.");
          }
        } else {
          const authKey = localStorage.getItem("authKey");
          const [response, departmentApprovalResponse, savedWorkDetails] = await Promise.all([
            axios.get(`${API_URL}/api/get_permit_details?permit_id=${permit_id}`, {
              headers: {
                Authorization: authKey, // Use 'Bearer' prefix if required
              },
            }),
            axios
              .get(`${API_URL}/api/permit/department/approvals/${permit_id}`, {
                headers: {
                  Authorization: authKey,
                },
              })
              .catch(() => null),
            isExcavationPermit
              ? axios.get(`${API_URL}/api/get_permit_work_details/${permit_id}`, {
                  headers: { Authorization: authKey },
                }).catch(() => null)
              : Promise.resolve(null),
          ]);

          if (response.data) {
            // Set all states from the single API response
            setPermitDetails(isExcavationPermit ? {
              ...response.data,
              excavationWorkDetails: savedWorkDetails?.data?.permit_details?.[0] || {},
            } : response.data);
            console.log("is_pending_request", response.data?.is_pending_request);
            setChecklist(response.data.checklistItems || []);
            setWorkDetails(response.data.workDetails || []);
            setClearanceRenewal(response.data.clearanceRenewal || []);
            setPrecautions(response.data.hazardsPrecautions || [{}]);
            setDepartmentApprovals(
              departmentApprovalResponse?.data?.department_approvals ||
                response.data.departmentApprovals ||
                []
            );
          } else {
            console.warn("No permit details found.");
            setError("No permit details found.");
          }
        }
      } catch (err) {
        console.error("Error fetching permit details:", err);
        setError("Failed to load permit details.");
      } finally {
        setLoading(false);
      }
    };

    fetchPermitDetails();
  }, [permit_id, isIsolationPermit, isExcavationPermit]);

  const handleSaveRejectClick = async () => {
    const payload = {
      permit_id: permit_id, // Maps to `permit_id` in backend
      request_type: "new", // Set `request_type` as "new"
      reason: reason, // From the form input
    };

    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");
      if (!authKey) {
        throw new Error("Authorization key not found");
      }

      // Make the API call
      const response = await axios.post(
        `${API_URL}/api/reject_permit`, // Ensure the method is POST
        payload,
        {
          headers: { Authorization: authKey },
        }
      );

      if (response.status === 200) {
        setSeverity("success");
        showSnackbar("Permit rejected successfully.");
        setTimeout(() => {
          navigate(`/cold-work-permit`);
        }, 1000);
      } else {
        throw new Error(response.data.message || "Failed to reject permit.");
      }
    } catch (error) {
      console.error("Error rejecting permit:", error);
      setSeverity("error");
      showSnackbar(
        error.response?.data?.message ||
          "An error occurred while rejecting the permit."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleSaveClick = async () => {
    try {
      // Retrieve the authKey from localStorage
      const authKey = localStorage.getItem("authKey");

      if (!authKey) {
        console.error("Authorization key not found");
        return;
      }

      // API call to approve the work permit
      const response = await axios.put(
        // `${API_URL}/api/approve_work_permit`,
        `${API_URL}/api/v2/fire_safety/approve`,
        { permit_id: permit_id, request_type: "new" }, // Send form_id in the request body
        {
          headers: {
            Authorization: authKey, // Pass the Authorization header
          },
        }
      );

      // Check the API response status
      if (response.status === 200) {
        console.log(response.data.message);
        setSeverity("success");
        showSnackbar("Work permit approved successfully!");
        setTimeout(() => {
          navigate("/work-permit-inspection");
        }, 1000);
      }
    } catch (error) {
      console.error("Error saving department:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleRejectClick = () => {
    setIsPopupOpen(true);
  };

  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleBack = () => {
    window.history.back();
  };

  const handleExcavationRemarkChange = (e) => {
    setExcavationRemark(e.target.value);
  };

  const handleExcavationFileChange = (e) => {
    setExcavationFile(e.target.files[0]);
  };

  const handleExcavationApprove = async () => {
    setIsLoading(true);

    try {
      const authKey = localStorage.getItem("authKey");
      const formData = new FormData();

      formData.append("permit_id", permit_id); // you should have permitId from props or state
      // formData.append("department_id", departmentId); // current department id
      formData.append("action", "Approve");
      formData.append("remarks", excavationRemark || "");

      if (excavationFile) {
        formData.append("attachments", excavationFile);
      }

      const response = await axios.post(
        `${API_URL}/api/permit/department/approve`,
        formData,
        {
          headers: {
            Authorization: authKey,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Approve Response:", response.data);
      alert(response.data.message || "Permit approved successfully!");
      setIsLoading(false);
      closeApprovePopup(); // your existing popup close function
    } catch (error) {
      console.error("Error approving permit:", error);
      alert(
        error.response?.data?.message ||
          "Failed to approve permit. Please try again."
      );
      setIsLoading(false);
    }
  };

  const handleExcavationReject = async () => {
    setIsLoading(true);

    try {
      const authKey = localStorage.getItem("authKey");
      const formData = new FormData();

      formData.append("permit_id", permit_id);
      // formData.append("department_id", departmentId);
      formData.append("action", "Reject");
      formData.append("remarks", excavationRemark || "");

      if (excavationFile) {
        formData.append("attachments", excavationFile);
      }

      const response = await axios.post(
        `${API_URL}/api/permit/department/approve`,
        formData,
        {
          headers: {
            Authorization: authKey,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Reject Response:", response.data);
      alert(response.data.message || "Permit rejected successfully!");
      setIsLoading(false);
      setShowRejectPopup(false);
    } catch (error) {
      console.error("Error rejecting permit:", error);
      alert(
        error.response?.data?.message ||
          "Failed to reject permit. Please try again."
      );
      setIsLoading(false);
    }
  };

  // Show loading state while fetching permit details
  if (loading) {
    return (
      <div
        className={`data-form-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-form-content">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "400px",
            }}
          >
            <div>Loading permit details...</div>
          </div>
        </div>
      </div>
    );
  }

  // Show error state if there's an error
  if (error) {
    return (
      <div
        className={`data-form-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-form-content">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "400px",
            }}
          >
            <div>Error: {error}</div>
          </div>
        </div>
      </div>
    );
  }

  // Render the component conditionally
  if (
    !permitDetails ||
    (isIsolationPermit ? !permitDetails.permit : !permitDetails.workDetails)
  ) {
    return (
      <div
        className={`data-form-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-form-content">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "400px",
            }}
          >
            <div>Loading permit data...</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        className={`data-form-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-form-content">
          <div className="data-form-header">
            <div className="data-form-header-content">
              <div className="data-form-heading-content-left-side">
                <Tooltip title="Back" arrow>
                  <IoMdArrowBack
                    className="back-company"
                    onClick={handleBack}
                  />
                </Tooltip>
                {decodedWorkPermitName === "Cold Work"
                  ? "Cold Work Permit Request View"
                  : decodedWorkPermitName === "Hot Work"
                  ? "Hot Work Permit Request View"
                  : decodedWorkPermitName === "Confined Space"
                  ? "Confined Space Work Permit Request View"
                  : decodedWorkPermitName ===
                    "Excavation Clearance/Road Closure"
                  ? "Excavation Clearance/Road Closure Work Permit Request View"
                  : isIsolationPermit
                  ? "Electrical Isolations/ Energisation Permit Request View"
                  : null}
              </div>

              {/* <div className="data-form-heading-content-right-side">
                {permitDetails.is_pending_request === true &&
                  (wp_status === "wp_requester" ||
                    ["wp_issuer", "wp_fands", "wp_oandm", "wp_E&R"].includes(
                      wp_status
                    )) && (
                    <>
                      {workDetails.request_status !== "Rejected" && (
                        <button
                          className={`data-form-save-button approverd-button-permit${
                            [
                              "Approved",
                              "Issued",
                              "Rejected",
                              "Renewed",
                              "Closed",
                              "Close Under Review",
                              "Extension Under Review",
                            ].includes(workDetails.request_status)
                              ? " disabled"
                              : ""
                          }`}
                          type="button"
                          onClick={handleApproveConfirm}
                          disabled={
                            isLoading ||
                            [
                              "Approved",
                              "Issued",
                              "Rejected",
                              "Renewed",
                              "Closed",
                              "Close Under Review",
                              "Extension Under Review",
                            ].includes(workDetails.request_status)
                          }
                        >
                          {[
                            "Approved",
                            "Renewed",
                            "Issued",
                            "Rejected",
                            "Closed",
                            "Close Under Review",
                            "Extension Under Review",
                          ].includes(workDetails.request_status) ? (
                            "Approved"
                          ) : isLoading ? (
                            <span className="loader" />
                          ) : (
                            "Approve"
                          )}
                        </button>
                      )}

                      {workDetails.request_status !== "Approved" && (
                        <button
                          className={`data-form-reject-button${
                            [
                              "Approved",
                              "Issued",
                              "Rejected",
                              "Renewed",
                              "Closed",
                              "Close Under Review",
                              "Extension Under Review",
                            ].includes(workDetails.request_status)
                              ? " disabled"
                              : ""
                          }`}
                          type="button"
                          onClick={() => setShowRejectPopup(true)}
                          disabled={
                            isLoading ||
                            [
                              "Approved",
                              "Issued",
                              "Rejected",
                              "Renewed",
                              "Closed",
                              "Close Under Review",
                              "Extension Under Review",
                            ].includes(workDetails.request_status)
                          }
                        >
                          {workDetails.request_status === "Rejected" ? (
                            "Rejected"
                          ) : isLoading ? (
                            <span className="loader" />
                          ) : (
                            "Reject"
                          )}
                        </button>
                      )}

                      {isApprovePopupOpen && (
                        <div className="permit-approval-popup">
                          <div className="permit-approval-popup-content">
                            <div className="approval-popup-header">
                              Confirm Approval
                            </div>
                            <p className="approval-popup-message">
                              Are you sure you want to approve this permit?
                            </p>
                            <div className="approval-popup-buttons">
                              <button
                                className="approve-button"
                                onClick={confirmApprove}
                              >
                                Yes, Approve
                              </button>
                              <button
                                className="cancel-button"
                                onClick={closeApprovePopup}
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      )}

                      {showRejectPopup && (
                        <div className="confirm-delete-popup">
                          <div className="confirm-delete-popup-content">
                            <div className="confirm-model">
                              <div className="confirm-model-content">
                                <div className="confirm-model-content-body">
                                  <p>
                                    Are you sure you want to reject this
                                    request?
                                  </p>
                                </div>
                                <div className="confirm-model-content-footer">
                                  <button
                                    className="reject-confirm-button"
                                    onClick={handleRejectConfirm}
                                  >
                                    Yes, Reject
                                  </button>
                                  <button
                                    className="reject-cancel-button"
                                    onClick={() => setShowRejectPopup(false)}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
              </div> */}
            </div>
          </div>
          <div className="header-separator"></div>

          <div className="data-form-body5656">
            {isPdfGenerating ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "400px",
                }}
              >
                <div>
                  <div
                    className="loader"
                    style={{ margin: "0 auto 10px" }}
                  ></div>
                  <div>Generating PDF...</div>
                </div>
              </div>
            ) : pdfUrl ? (
              <iframe
                src={pdfUrl}
                style={{ width: "100%", height: "calc(100vh - 120px)" }}
                title="PDF Preview"
              />
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "400px",
                }}
              >
                <div>Unable to generate PDF. Please try again.</div>
              </div>
            )}
          </div>

          <div className="pdf-view-data" style={{ display: "none" }}>
            <div ref={pdfRef}>
              {permitDetails && !isPdfGenerating && (
                <div className="pdf-view-data">
                  <div ref={pdfRef}>
                    {decodedWorkPermitName === "Cold Work" && (
                      <ColdWorkPermitTemplate
                        permitDetails={permitDetails}
                        isSidebarExpanded={isSidebarExpanded}
                      />
                    )}
                    {decodedWorkPermitName === "Hot Work" && (
                      <HotWorkPermitTemplate
                        permitDetails={permitDetails}
                        isSidebarExpanded={isSidebarExpanded}
                      />
                    )}
                    {decodedWorkPermitName === "Confined Space" && (
                      <ConfinedSpaceTemplate
                        permitDetails={permitDetails}
                        isSidebarExpanded={isSidebarExpanded}
                      />
                    )}

                    {/* {work_permit_name === "Excavation Clearance/Road Closure" && (
                      <RoadClosureTemplate
                        permitDetails={permitDetails}
                        isSidebarExpanded={isSidebarExpanded}
                      />
                    )} */}

                    {isIsolationPermit && (
                      <IsolationPermitTemplate
                        permitDetails={permitDetails}
                        isSidebarExpanded={isSidebarExpanded}
                      />
                    )}

                    {decodedWorkPermitName ===
                      "Excavation Clearance/Road Closure" && (
                      <RoadClosureTemplate
                        permitDetails={permitDetails}
                        isSidebarExpanded={isSidebarExpanded}
                        departmentApprovals={
                          permitDetails?.departmentApprovals ||
                          departmentApprovals
                        }
                      />
                    )}

                    {/* {decodedWorkPermitName ===
                      "Excavation Clearance/Road Closure" && (
                      <RoadClosureTemplate
                        permitDetails={permitDetails}
                        isSidebarExpanded={isSidebarExpanded}
                        departmentApprovals={departmentApprovals}
                      />
                    )} */}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {isPopupOpen && (
          <div className="permit-popup-model">
            <div className="permit-popup-content">
              <div className="reminder-popup-model-header">
                <div className="reminder-popup-model-content-header">
                  <div className="reminder-popup-model-content-header-left-part">
                    Reject Request Permit
                  </div>
                  <div className="reminder-popup-model-content-header-right-part"></div>
                </div>
                <div className="popup-new-form">
                  <form className="permit-popup-form-detail">
                    <div className="new-data-form">
                      <div className="form-group email-filed">
                        <label htmlFor="reason">
                          Reason <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <textarea
                            id="reason"
                            name="reason"
                            placeholder="Enter reason for rejected"
                            value={reason}
                            onChange={handleReasonChange}
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="footers">
                  <div className="button-group-email">
                    <div>
                      <button
                        className="person-user-save-button"
                        type="button"
                        onClick={handleSaveRejectClick}
                        disabled={isLoading}
                      >
                        {/* {isLoading ? "Saving..." : "Save"} */}
                        Ok
                      </button>

                      <button
                        className="person-user-cancel-button"
                        onClick={closePopup}
                      >
                        Cancel
                      </button>
                    </div>
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000} // Converted to milliseconds
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={severity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default PermitPdfFormate;
